import FullWidthLayout from "@/layouts/FullWidthLayout";
import { KPageIndex } from "kinnect-general";
import { Pageable } from "kinnect-mixins";

export default {
	name: "FacilityMaintenancePage",

	metaInfo: { title: "Facility Maintenance" },

	mixins: [ Pageable ],

	data: () => ( {
		items: [
			{
				icon: "contacts",
				title: "Contacts",
				to: { name: "facilityMaintenanceContacts" }
			},
			{
				icon: "assignment_ind",
				title: "Vendors",
				to: { name: "facilityMaintenanceVendors" }
			},
			{
				icon: "view_list",
				title: "Vendor Categories",
				to: { name: "facilityMaintenanceVendorTypes" }
			},
			{
				icon: "build",
				title: "Work Orders",
				to: { name: "facilityMaintenanceWorkOrders" }
			}
		]
	} ),

	render() {
		return <FullWidthLayout>
			<KPageIndex
				autoSort={false}
				items={this.items}
			></KPageIndex>
		</FullWidthLayout>;
	}
};
